"use strict";
/**
 * TEMP: mega menu test script — will be replaced by frontend implementation.
 *
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.initMegaMenu = void 0;
const CONTAINER_ID = 'mega-menu-container';
const PANEL_SELECTOR = '[data-mega-menu-panel]';
const LINK_SELECTOR = '[data-mega-menu-group]';
const TOGGLE_SELECTOR = '.mega-menu-toggle';
const MOBILE_PANEL_SELECTOR = '[data-mobile-mega-panel]';
function initMegaMenu() {
    const container = document.getElementById(CONTAINER_ID);
    // ── Mobile toggle buttons ────────────────────────────────────────
    // Operate on inline mobile panels (data-mobile-mega-panel) rendered
    // inside .o-mobile-nav, independent of the desktop container.
    const closeAllMobilePanels = () => {
        document.querySelectorAll(MOBILE_PANEL_SELECTOR).forEach((panel) => {
            panel.classList.remove('is-open');
        });
        document.querySelectorAll(TOGGLE_SELECTOR).forEach((btn) => {
            btn.classList.remove('is-open');
        });
    };
    document.querySelectorAll(TOGGLE_SELECTOR).forEach((btn) => {
        btn.addEventListener('click', (e) => {
            e.preventDefault();
            const target = e.currentTarget;
            const group = target.getAttribute('data-mega-menu-group');
            const index = target.getAttribute('data-mega-menu-index');
            if (!group || !index)
                return;
            const parentItem = target.closest('.o-mobile-nav__item');
            const mobilePanel = parentItem
                ? parentItem.querySelector(`[data-mobile-mega-panel="${group}-${index}"]`)
                : null;
            if (mobilePanel) {
                const wasOpen = mobilePanel.classList.contains('is-open');
                closeAllMobilePanels();
                if (!wasOpen) {
                    mobilePanel.classList.add('is-open');
                    target.classList.add('is-open');
                }
            }
        });
    });
    // ── Desktop hover panels ─────────────────────────────────────────
    // Only wire up desktop behaviour when the container exists.
    if (!container)
        return;
    const closeAll = () => {
        container.querySelectorAll(PANEL_SELECTOR).forEach((panel) => {
            panel.hidden = true;
            panel.setAttribute('aria-hidden', 'true');
        });
        wrapper === null || wrapper === void 0 ? void 0 : wrapper.classList.remove('menu-open');
    };
    const openPanel = (group, index) => {
        closeAll();
        const panel = container.querySelector(`[data-mega-menu-panel="${group}-${index}"]`);
        if (panel) {
            panel.hidden = false;
            panel.setAttribute('aria-hidden', 'false');
            wrapper === null || wrapper === void 0 ? void 0 : wrapper.classList.add('menu-open');
        }
    };
    document.querySelectorAll(LINK_SELECTOR).forEach((link) => {
        link.addEventListener('mouseenter', (e) => {
            const target = e.currentTarget;
            const group = target.getAttribute('data-mega-menu-group');
            const index = target.getAttribute('data-mega-menu-index');
            if (group && index) {
                openPanel(group, index);
            }
        });
    });
    // Close panels when the cursor leaves the whole navigation wrapper
    const wrapper = container.closest('.o-navigation-wrapper') || container.parentElement;
    if (wrapper) {
        wrapper.addEventListener('mouseleave', closeAll);
    }
}
exports.initMegaMenu = initMegaMenu;
